/**
 * @generated SignedSource<<72f8ff749a8336993ab20d82a1d34572>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Weekday = "FRIDAY" | "MONDAY" | "SATURDAY" | "SUNDAY" | "THURSDAY" | "TUESDAY" | "WEDNESDAY" | "%future added value";
export type settingsOneDeliveryQuery$variables = Record<PropertyKey, never>;
export type settingsOneDeliveryQuery$data = {
  readonly onedeliveryProfile: {
    readonly deliveryWeekdays: ReadonlyArray<Weekday>;
    readonly preferredHub: {
      readonly id: string;
      readonly meta: {
        readonly city: string;
        readonly id: string;
        readonly name: string;
        readonly postalCode: string;
        readonly street: string;
      } | null | undefined;
    };
  } | null | undefined;
};
export type settingsOneDeliveryQuery = {
  response: settingsOneDeliveryQuery$data;
  variables: settingsOneDeliveryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OnedeliveryProfile",
    "kind": "LinkedField",
    "name": "onedeliveryProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deliveryWeekdays",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Hub",
        "kind": "LinkedField",
        "name": "preferredHub",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HubMeta",
            "kind": "LinkedField",
            "name": "meta",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "street",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "settingsOneDeliveryQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "settingsOneDeliveryQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "178975123b5a2f36edafd4a348516a62",
    "id": null,
    "metadata": {},
    "name": "settingsOneDeliveryQuery",
    "operationKind": "query",
    "text": "query settingsOneDeliveryQuery {\n  onedeliveryProfile {\n    deliveryWeekdays\n    preferredHub {\n      id\n      meta {\n        id\n        name\n        street\n        postalCode\n        city\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "51043eb1681470fdb90b14b2779f35c6";

export default node;
